import { Merchandise } from "types";
import { CreatePurchaseItemState, useCreatePurchaseStore } from "@/stores/createPurchaseStore";

export const getMerchandiseValidations = () => {
    const merchandise = useCreatePurchaseStore.getState().getActiveProduct<Merchandise>();
    const item = useCreatePurchaseStore.getState().getActiveItem();

    const getDisabledReasons = () => {
        if (!merchandise) {
            return [];
        }

        return getMerchandiseItemDisabledReasons(item);
    };

    return { getDisabledReasons };
};

export const getMerchandiseItemDisabledReasons = (item: CreatePurchaseItemState) => {
    const messages = [];

    const totalQuantity = item.quantity ?? 0;
    if (totalQuantity === 0) {
        messages.push("Select at least one variant");
    }

    return messages;
};
